
const makeMenuItems = (pluginItems) => {
  const items = [
    {text:'지도', value:'maps', icon:'maps', classes: 'tistory-plugin-item', cmd:'openMap'},
    {text:'서식', value:'template', icon:'template', classes: 'tistory-plugin-item', cmd:'openTemplate'},
    {text:'접은글', value:'moreless', icon:'fold', classes: 'tistory-plugin-item', cmd:'cmdMoreLess'},
    {text:'특수문자', value:'special', icon:'special_character', classes: 'tistory-plugin-item', cmd:'kCharmap'},
    {text:'코드블럭', value:'codeblock', icon:'codesample', classes: 'tistory-plugin-item', cmd:'codeblock'},
  ]

  if (pluginItems.length > 0) {
    items.push({
      text:'플러그인',
      value:'tistoryplugins',
      icon: 'plugin',
      classes: 'tistory-plugin-item',
      menu: pluginItems.map(plugin => ({
        text: plugin.title,
        value: plugin.title,
        onClick: (e) => {
          e.preventDefault();
          window.open(plugin.url + '?editor=8', plugin.title, `width=${plugin.width},height=${plugin.height}`);
        }
      }))
    })
  }

  return items
}

const plugin = function(editor) {
  const settings = editor.settings.tistory_plugins
  let pluginItems = []
  let openTemplateHandler = () => {}
  if (settings) {
    if (settings.open_template_handler) {
      openTemplateHandler = settings.open_template_handler
    }

    if (settings.plugins) {
      pluginItems = settings.plugins
    }
  }

  editor.addCommand('openTemplate', () => {
    openTemplateHandler(editor.selection.getRng());
  });

  editor.addButton('tistory-plugins', {
    type: 'SimpleMenuButton',
    icon: 'more',
    fixedWidth: true,
    tooltip: '더보기',
    menu: {
      type: 'menu',
      items: makeMenuItems(pluginItems)
    },
    onSelect(e) {
      if (e.control.settings.cmd) {
        editor.execCommand(e.control.settings.cmd)
      }
    },
    onShowMenu() {
      this.menu.moveRel(this.getEl(), ['bc-tc', 'tc-bc']);
    },
    disabledStateSelector: 'td'
  })
}

export default plugin
